/** show input text value as italic text */
export const italicFormatter = (_row, _cell, value) => {
    return value ? `<i>${value}</i>` : '';
};
//# sourceMappingURL=italicFormatter.js.map